import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { EMPLOYEE_ROUTES } from '../../../constants/employee.routing.constants';
import { ProfileDropdownItem } from '../profile-dropdown.model';
import { ProfileDropdownMenuHeaderComponent } from './profile-dropdown-menu-header/profile-dropdown-menu-header.component';
import { ProfileDropdownMenuItemComponent } from './profile-dropdown-menu-item/profile-dropdown-menu-item.component';

@Component({
  selector: 'lib-profile-dropdown-menu',
  imports: [ProfileDropdownMenuHeaderComponent, ProfileDropdownMenuItemComponent],
  templateUrl: './profile-dropdown-menu.component.html',
  styleUrl: './profile-dropdown-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProfileDropdownMenuComponent {
  readonly EMPLOYEE_ROUTES = EMPLOYEE_ROUTES;

  profileMenuItems = input.required<ProfileDropdownItem[]>();
  action = output<ProfileDropdownItem>();

  selectMenuItem(item: ProfileDropdownItem) {
    this.action.emit(item);
  }
}
